import InputField from '../admin/InputField';
import UploadImage from "../admin/UploadImage";
import { Authorization } from '../../providers/AuthContextProvider';
import useAxios from '../../hooks/useAxios';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NewTicket = () => {
    const push = useNavigate()
    const { user } = useContext(Authorization)
    const { AxiosPrivate } = useAxios()

    const [data, setData] = useState({ name: '', phone: '', subject: '', message: '', images: [] });
    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!Object.keys(user).length) {
            if (window.confirm('وارد حساب نشده اید آیا میخواهید وارد شوید؟')) {
                push('/auth/login')
                return
            } else return
        } else if (!data.name.trim() || !data.phone.trim() || !data.subject.trim() || !data.message.trim()) {
            alert('همه فیلد ها به جز عکس اجباری هستند')
            return
        } else {
            setLoading(true)
            await AxiosPrivate.post('/ticket/store', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(res => {
                    alert(res.data.message)
                    setData({ name: '', phone: '', subject: '', message: '', images: [] })
                })
                .catch(err => alert(err.response?.data.message))
                .finally(() => setLoading(false))
        }
    };
    return (
        <>
            <div className="my-4">
                <form onSubmit={handleSubmit} className="relative p-4 border-2 rounded-lg">
                    <span className='absolute -top-4 right-4 bg-white border-2 px-2.5 py-1 text-sm rounded-3xl text-gray-500'>پیام مستقیم</span>
                    <div className="flex flex-wrap items-center justify-between mt-6 gap-x-1">
                        <div className="max-w-[100%] w-full mb-6">
                            <div className='w-fit mx-auto'>
                                <UploadImage setData={setData} label='عکس' name='images' withSizeValidation images={data.images} />
                            </div>
                        </div>
                        <InputField label={'نام و نام‌خانوادگی'} id={1} max_width={'49%'} name={'name'} type={'text'} isValidated={false} {...{ data, handleChange }} />
                        <InputField label={'شماره تماس'} id={2} max_width={'49%'} name={'phone'} type={'tel'} isValidated={false} {...{ data, handleChange }} />
                        <InputField label={'موضوع'} id={3} max_width={'100%'} name={'subject'} type={'text'} isValidated={false} {...{ data, handleChange }} />
                        <div className="relative pb-6 mb-4 max-w-[100%] w-full">
                            <div className="w-full relative">
                                <textarea rows="5" name='message' value={data.message} onChange={handleChange}
                                    className="block focus:border-primary px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 appearance-none dark:text-white focus:outline-none focus:ring-0 peer"
                                    placeholder="متن پیام"
                                />
                                <span className="absolute -top-6 left-3">{data.message?.length}</span>
                            </div>
                        </div>
                        <button disabled={loading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                                        focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-auto">{loading ?
                                <div role="status">
                                    <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                : 'ارسال'}</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default NewTicket;